/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { reconciliation_CandidateInvoiceSplitDTO } from './reconciliation_CandidateInvoiceSplitDTO';
import type { reconciliation_DebtorAccountSummaryDTO } from './reconciliation_DebtorAccountSummaryDTO';
export type reconciliation_CandidateDTO = {
    confidence?: number;
    counterpartyMatchScore?: number;
    debtorAccount?: reconciliation_DebtorAccountSummaryDTO;
    debtorAccountId: string;
    isTopCandidate?: boolean;
    matchedVia?: Array<string>;
    openInvoiceSplits?: Array<reconciliation_CandidateInvoiceSplitDTO>;
    preSelectedSplitIds?: Array<string>;
    source?: reconciliation_CandidateDTO.source;
};
export namespace reconciliation_CandidateDTO {
    export enum source {
        AUTO = 'auto',
        SEARCH = 'search',
        MANUAL = 'manual',
    }
}

